module.exports = __webpack_public_path__ + "static/media/piston-1.ec63f2de.mp3";